var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "videoSourceSection",
      staticClass: "card-video-source-section m-t-20",
      class: { "vue-inited": _vm.card },
      attrs: { id: "card-video-source-section" }
    },
    [
      _c("div", { staticClass: "m-b-10" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-8" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.card.video_source_type,
                  expression: "card.video_source_type"
                }
              ],
              staticClass: "radio-custom",
              attrs: { id: "src-url", type: "radio", value: "url" },
              domProps: { checked: _vm._q(_vm.card.video_source_type, "url") },
              on: {
                change: function($event) {
                  return _vm.$set(_vm.card, "video_source_type", "url")
                }
              }
            }),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "radio-custom-label", attrs: { for: "src-url" } },
              [_vm._v("URL")]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-4" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.card.video_source_type,
                  expression: "card.video_source_type"
                }
              ],
              staticClass: "radio-custom",
              attrs: { id: "src-file", type: "radio", value: "file" },
              domProps: { checked: _vm._q(_vm.card.video_source_type, "file") },
              on: {
                change: function($event) {
                  return _vm.$set(_vm.card, "video_source_type", "file")
                }
              }
            }),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "radio-custom-label", attrs: { for: "src-file" } },
              [_vm._v("File Upload")]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.video_source_type === "file",
              expression: "video_source_type === 'file'"
            }
          ]
        },
        [
          _c("input", {
            attrs: { type: "hidden", name: "card[media_video_id]" },
            domProps: { value: _vm.media_video_id }
          }),
          _vm._v(" "),
          _c("video-form", {
            attrs: { holder: "card", id: _vm.media_video_id },
            on: {
              "update:media_video_id": function($event) {
                _vm.card.media_video_id = $event
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.video_source_type === "url",
              expression: "video_source_type === 'url'"
            }
          ],
          staticClass: "card-video-source"
        },
        [
          _c("input", {
            attrs: { type: "hidden", name: "card[video]" },
            domProps: { value: _vm.card.video }
          }),
          _vm._v(" "),
          _c("input", {
            attrs: { type: "hidden", name: "card[embed_url_info_id]" },
            domProps: { value: _vm.card.embed_url_info_id }
          }),
          _vm._v(" "),
          _c("input", {
            attrs: { type: "hidden", name: "card[video_poster][own_url]" },
            domProps: { value: _vm.card.video_poster.own_url }
          }),
          _vm._v(" "),
          _c("input", {
            attrs: { type: "hidden", name: "card[video_poster][url]" },
            domProps: { value: _vm.card.video_poster.url }
          }),
          _vm._v(" "),
          _c("input", {
            attrs: { type: "hidden", name: "card[video_source_type]" },
            domProps: { value: _vm.card.video_source_type }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "m-b-30 form-group form-group40 group-row",
              staticStyle: { position: "relative" }
            },
            [
              _c("div", { staticClass: "row center no-pd active" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.card.video_source_url,
                      expression: "card.video_source_url"
                    }
                  ],
                  staticClass: "form-control large_body inputs",
                  attrs: {
                    id: "source_url",
                    placeholder: "Paste your URL link here",
                    type: "text"
                  },
                  domProps: { value: _vm.card.video_source_url },
                  on: {
                    keydown: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.onBlurVideoSourceUrl($event)
                    },
                    blur: _vm.onBlurVideoSourceUrl,
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.card,
                        "video_source_url",
                        $event.target.value
                      )
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "text-right small",
                    class: { error: _vm.video_source_error }
                  },
                  [_vm._v(_vm._s(_vm.video_source_status))]
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "m-b-30 form-group form-group40 i-field video-title-field"
            },
            [
              _c("div", { staticClass: "row center no-pd active" }, [
                _vm._m(1),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.card.title,
                      expression: "card.title"
                    }
                  ],
                  staticClass: "form-control large_body card-title inputs",
                  attrs: {
                    type: "text",
                    name: "card[title]",
                    placeholder: "Card Title",
                    maxlength: "256"
                  },
                  domProps: { value: _vm.card.title },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.card, "title", $event.target.value)
                    }
                  }
                })
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.video_source_valid,
                  expression: "video_source_valid"
                }
              ],
              staticClass: "m-b-40"
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.card.embed_url_info.embed_content,
                      expression: "card.embed_url_info.embed_content"
                    }
                  ],
                  staticClass: "card-image-section"
                },
                [
                  _c("div", { staticClass: "media-content" }, [
                    _vm.card.video_poster.url
                      ? _c(
                          "div",
                          {
                            staticClass: "embed-section",
                            style: {
                              "background-image":
                                "url(" + _vm.card.video_poster.url + ")"
                            },
                            on: {
                              click: function($event) {
                                _vm.embedAutoPlay = true
                              }
                            }
                          },
                          [
                            !_vm.embedAutoPlay
                              ? _c("i", { staticClass: "fa fa-play-circle" })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.embedAutoPlay
                              ? _c("div", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.autoplay_embed_content
                                    )
                                  }
                                })
                              : _vm._e()
                          ]
                        )
                      : _c("div", {
                          staticClass: "embed-section",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.card.embed_url_info.embed_content
                            )
                          }
                        })
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.card.embed_url_info.id,
                      expression: "!card.embed_url_info.id"
                    }
                  ]
                },
                [
                  _vm.card.video_poster.url
                    ? _c("video", {
                        attrs: {
                          poster: _vm.card.video_poster.url,
                          src: _vm.card.video_source_url,
                          controls: ""
                        }
                      })
                    : _c("video", {
                        attrs: { src: _vm.card.video_source_url, controls: "" }
                      })
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.video_source_valid,
                  expression: "video_source_valid"
                }
              ],
              staticClass: "m-b-40 thumbnails"
            },
            [
              _c("h6", [_vm._v("Thumbnail")]),
              _vm._v(" "),
              _c("div", { staticClass: "row m-b-10" }, [
                _c("div", { staticClass: "col-md-6" }, [
                  _c(
                    "div",
                    {
                      staticClass: "thumb-uploaded",
                      on: {
                        click: function($event) {
                          return _vm.setUrlPoster(_vm.card.video_poster.own_url)
                        }
                      }
                    },
                    [
                      _vm.card.video_poster.url &&
                      _vm.card.video_poster.url ===
                        _vm.card.video_poster.own_url
                        ? _c("div", { staticClass: "fa fa-check" })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("thumbnail-dropzone2", {
                        attrs: {
                          elem_id: "dropzone-card-poster-file",
                          max_size: "10",
                          img_src: _vm.card.video_poster.own_url,
                          form_selector: _vm.form_selector
                        },
                        on: {
                          "update:img_src": function($event) {
                            _vm.card.video_poster.own_url = $event
                          }
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-6" }, [
                  _vm.card.embed_url_info.img_src
                    ? _c("div", { staticClass: "dropzone-area auto-thunb" }, [
                        _c("img", {
                          attrs: { src: _vm.card.embed_url_info.img_src },
                          on: {
                            click: function($event) {
                              return _vm.setUrlPoster("")
                            }
                          }
                        }),
                        _vm._v(" "),
                        !_vm.card.video_poster.url
                          ? _c("div", { staticClass: "fa fa-check" })
                          : _vm._e()
                      ])
                    : _vm._e()
                ])
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("modal-dont-leave")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "label-control" }, [
      _c(
        "span",
        { staticClass: "label-text required", staticStyle: { top: "0" } },
        [_vm._v("URL")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "label-control" }, [
      _c("span", { staticClass: "label-text required" }, [_vm._v("Card Title")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }